// extracted by mini-css-extract-plugin
export default {"result":"result_result__Exghz","pdf":"result_pdf__Z9W3u","links":"result_links__Y++oy","linkBttn":"result_linkBttn__EEV0m","red":"result_red__HzIim","green":"result_green__7PQbg"};